import React from 'react'
import { measurements } from '@mobi/component-library/Foundations'
import { setAppHeaderFixedState } from '@core/Areas/AppHeader/Store'
import { useAppDispatch } from '@core/Store/hooks'

const enum LocalConstants {
  appContentInsetTopCssVariable = '--app-header-fixed-height',
}

/** Only to be used on top level page routes - otherwise changes required */
export const useForceAppHeaderFixed = () => {
  const dispatch = useAppDispatch()

  React.useEffect(() => {
    const setCssAppHeaderFixedHeightVariable = (value: string) => {
      document.documentElement.style.setProperty(
        LocalConstants.appContentInsetTopCssVariable,
        value
      )
    }

    const handleAppHeaderFix = () => {
      if (window.innerHeight < 600) {
        setCssAppHeaderFixedHeightVariable('0px')
        dispatch(setAppHeaderFixedState('relative'))
      } else {
        dispatch(setAppHeaderFixedState('fixed'))
        setCssAppHeaderFixedHeightVariable(measurements.mobi.headerHeight)
      }
    }

    handleAppHeaderFix()
    window.addEventListener('resize', handleAppHeaderFix)

    return () => {
      dispatch(setAppHeaderFixedState(null))
      setCssAppHeaderFixedHeightVariable('0px')
      window.removeEventListener('resize', handleAppHeaderFix)
    }
  }, [dispatch])
}
